import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Fires the iSpot TV conversion "visit" pixel on initial load and on every
// client-side route change, so SPA navigations count as page visits.
// The pixel itself (and its consent gate) is defined in public/index.html.
export default function ISpotPixel() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        if (window.__kfFireISpot) {
            window.__kfFireISpot();
        }
    }, [pathname, search]);

    return null;
}
